// React
import React, { useMemo, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Chakra
import { Box, Portal, useDisclosure } from '@chakra-ui/react';

// Contexts
import { SidebarContext } from 'contexts/SidebarContext';
import { useAuth } from 'contexts/AuthContext';

// Layout components
import Navbar from 'components/navbar/NavbarAdmin';
import Footer from 'components/footer/FooterAdmin';
import MainLayout from 'components/sidebar/Sidebar'; // ✅ IMPORTANT
import GlobalLoader from "components/loaders/GlobalLoader";

// Routes builder
import { getRoutes } from 'routes';

export default function AdminLayout(props) {
  const { auth } = useAuth();
  const { onOpen } = useDisclosure();

  const [fixed] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);

  const routes = useMemo(() => {
    return getRoutes(auth.accessDetails || [], auth.isAdmin);
  }, [auth.accessDetails, auth.isAdmin]);

  const activeRoute = useMemo(() => {
    return routes.find(route =>
      window.location.pathname.includes(`${route.layout}/${route.path}`)
    )?.name || '';
  }, [routes]);

  return (
    <SidebarContext.Provider
      value={{ toggleSidebar, setToggleSidebar, isMenuOpen, setIsMenuOpen }}
    >
      <MainLayout routes={routes}>
        <GlobalLoader />
        <Portal>
          <Box>
            <Navbar
              onOpen={onOpen}
              brandText={activeRoute}
              fixed={fixed}
              {...props}
            />
          </Box>
        </Portal>

        <Box mx="auto" p={{ base: '10px', md: '20px' }} minH="100vh" pt="50px">
          <Routes>
            {routes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={route.component}
              />
            ))}

            <Route index element={<Navigate to="Timesheet" replace />} />
          </Routes>
        </Box>

        <Footer />
      </MainLayout>
    </SidebarContext.Provider>
  );
}
